import React from 'react';
import { Box } from 'components/primitives/box';
import PassengerCounter from 'components/forms/bookingWidget/PassengerCounter';
import type { UseFormMethods } from 'react-hook-form';

interface PassengerInputProps {
  isModal: boolean;
  register: UseFormMethods['register'];
}
export default ({ isModal, register }: PassengerInputProps) => (
  <Box padding={`${isModal ? 0 : '20px'} 0 0`}>
    <PassengerCounter />
    <input type="hidden" ref={register({ required: 'Please enter passenger amount' })} name="passengers" />
  </Box>
);
